import _asyncToGenerator from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.regexp.search.js";
import OAuth from "../../oauth";
import { redirectIfNewPortalCustomer } from "./portalVersion";
var auth = new OAuth();
export default function (_x, _x2, _x3) {
  return _ref.apply(this, arguments);
}
function _ref() {
  _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(to, from, next) {
    var user, _t;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 1;
          return auth.currentUser();
        case 1:
          user = _context.sent;
          if (!user) {
            _context.next = 6;
            break;
          }
          if (!(user.get('email_verified_at') || user.get('mobile_verified_at'))) {
            _context.next = 4;
            break;
          }
          _context.next = 2;
          return redirectIfNewPortalCustomer(user);
        case 2:
          if (!_context.sent) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return");
        case 3:
          next();
          _context.next = 5;
          break;
        case 4:
          next('/verify' + window.location.search);
        case 5:
          _context.next = 7;
          break;
        case 6:
          next('/login' + window.location.search);
        case 7:
          _context.next = 9;
          break;
        case 8:
          _context.prev = 8;
          _t = _context["catch"](0);
          // Handle different error types appropriately
          if (_t.response && _t.response.status === 403) {
            // 403 means user is authenticated but needs verification
            next('/verify' + window.location.search);
          } else if (_t.response && (_t.response.status === 401 || _t.response.status === 429)) {
            // 401/429 means user needs to login again
            next('/login' + window.location.search);
          } else {
            next('/login' + window.location.search);
          }
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 8]]);
  }));
  return _ref.apply(this, arguments);
}